<template>
  <div class="settings q-gutter-y-lg row q-gutter-x-lg">
    <q-tabs
      :class="{ 'width-200': $q.screen.gt.xs }"
      active-color="primary"
      inline-label
      switch-indicator
      vertical
    >
      <q-route-tab
        :label="$q.screen.gt.xs ? 'Profile' : undefined"
        :to="{ name: 'Profile' }"
        icon="person"
        no-caps
        style="justify-content: left; padding-left: 16px"
      />
      <q-route-tab
        :label="$q.screen.gt.xs ? 'Organization' : undefined"
        :to="{ name: 'Organization' }"
        icon="business"
        no-caps
        style="justify-content: left; padding-left: 16px"
      >
      </q-route-tab>
      <q-route-tab
        v-if="isHelloDataEmployee"
        :label="$q.screen.gt.xs ? 'Admin' : undefined"
        :to="{ name: 'Admin' }"
        icon="admin_panel_settings"
        no-caps
        style="justify-content: left; padding-left: 16px"
      />
      <q-route-tab
        :disable="!hasBillingPortalUrl"
        :label="$q.screen.gt.xs ? 'Billing' : undefined"
        :to="{ name: 'Billing' }"
        icon="account_balance"
        no-caps
        style="justify-content: left; padding-left: 16px"
      />
      <q-route-tab
        :label="$q.screen.gt.xs ? 'Help Center' : undefined"
        href="https://www.hellodata.ai/learning-hub"
        icon="help"
        no-caps
        rel="noopener noreferrer"
        style="justify-content: left; padding-left: 16px"
        target="_blank"
      >
        <q-icon v-if="$q.screen.gt.xs" class="q-ml-sm" name="launch" />
      </q-route-tab>
      <div class="column q-ma-md">
        <a
          href="https://www.hellodata.ai/terms"
          rel="noopener noreferrer"
          style="text-decoration: none; color: inherit"
          target="_blank"
        >
          Terms
        </a>
        <a
          :class="{ 'width-39': $q.screen.xs }"
          href="https://www.hellodata.ai/privacy-policy"
          rel="noopener noreferrer"
          style="text-decoration: none; color: inherit"
          target="_blank"
        >
          Privacy Policy
        </a>
      </div>
    </q-tabs>
    <div class="col">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { useStripeStore } from '@/stores/stripe'
import { useUserStore } from '@/stores/user'

export default {
  name: 'SettingsView',
  components: {},
  data() {
    return {
      hasBillingPortal: false
    }
  },
  computed: {
    products() {
      return this.$auth0.user.value?.products
    },
    organization() {
      return useUserStore().organization
    },
    isHelloDataEmployee() {
      return useUserStore().isHelloDataEmployee
    },
    hasBillingPortalUrl() {
      return useStripeStore().hasCustomerPortal
    }
  }
}
</script>
<style scoped>
.settings {
  max-width: 1280px;
  margin: auto;
}
.width-200 {
  width: 200px;
}
.width-39 {
  width: 39px;
}
</style>
